import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Apple, Smartphone } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { WaitlistForm } from "./WaitlistForm";

const StoreBtn = ({ icon: Icon, small, big, id }) => (
  <a href="#early-access" data-testid={`store-btn-${id}`} title="Store link placeholder"
    className="inline-flex items-center gap-3 rounded-2xl border border-white/15 bg-black px-5 py-3 transition-[border-color,transform] hover:-translate-y-0.5 hover:border-white/40">
    <Icon className="h-6 w-6" />
    <span className="leading-tight text-left">
      <span className="block text-[11px] text-zinc-400">{small}</span>
      <span className="block text-sm font-semibold">{big}</span>
    </span>
  </a>
);

export const AppCta = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [80, -80]);
  return (
    <section id="early-access" ref={ref} className="mx-auto max-w-7xl px-5 sm:px-8 py-24 lg:py-36" data-testid="app-cta-section">
      <div className="relative overflow-hidden rounded-[2rem] bg-[#FF3838] text-[#0A0B0E] grid lg:grid-cols-12">
        <Reveal className="lg:col-span-7 p-8 sm:p-14">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#0A0B0E]/70">Early access</p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[0.95]">
            Don't wait.<br />That's kind of the point.
          </h2>
          <p className="mt-6 max-w-md text-[#0A0B0E]/80">Join the list to hear first when the web marketplace opens on urgentsellbuy.com. The mobile app is coming to the stores too.</p>
          <div className="mt-8 max-w-lg rounded-3xl bg-[#0A0B0E] p-4 text-white">
            <WaitlistForm testPrefix="cta" />
          </div>
          <div className="mt-6 flex flex-wrap gap-3 text-white">
            <StoreBtn id="ios" icon={Apple} small="[App Store link]" big="App Store" />
            <StoreBtn id="android" icon={Smartphone} small="[Google Play link]" big="Google Play" />
          </div>
        </Reveal>
        <div className="lg:col-span-5 relative min-h-[360px] lg:min-h-0">
          <motion.div style={{ y }} className="absolute inset-x-8 top-8 bottom-[-40px] lg:inset-x-10 lg:top-16">
            <div className="h-full overflow-hidden rounded-t-[2.5rem] border-[10px] border-b-0 border-[#0A0B0E] bg-[#0A0B0E] shadow-2xl">
              <img src="/img/lifestyle.jpg" alt="Person shopping on a phone" className="h-full w-full object-cover" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
